import React from "react";
import tocDi from "@frameworks/web/components/features/TOC/di/servicelocator";
import { useSelector } from "react-redux";
import { tocRoutes } from "../../features/TOC/constant";
import TocHoc from "../../features/TOC/TocHoc";
import DeviceContext from "@frameworks/web/components/generic/customHooks/indentifyDevice";
import { getQueryParameterName } from "@frameworks/web/utils/urlHelper";
import { OrderbookTocStateEnum, } from "@frameworks/web/components/features/OrderBook/constant";
import { isEqual } from "underscore";
const TocOnBuySell = (props) => {
    var _a;
    const device = DeviceContext();
    const queryParamSymbol = getQueryParameterName("syml");
    const [afterLogin, setAfterLogin] = React.useState(false);
    const isUserLoggedIn = () => {
        let userLoggedIn = false;
        const jwtToken = window.localStorage.getItem("jwt_token");
        if (jwtToken !== undefined && jwtToken !== null && jwtToken !== "") {
            userLoggedIn = true;
        }
        else
            userLoggedIn = false;
        return userLoggedIn;
    };
    const [symbol, setSymbol] = React.useState("");
    const multiQuoteData = useSelector((state) => state.TOCJourney.multiQuoteReducers, isEqual);
    const getMultiQuoteDetails = (symbol) => {
        if (symbol) {
            tocDi.tocJourney.getMultiQuoteData({
                symLst: [symbol],
                isModifyOrder: (props === null || props === void 0 ? void 0 : props.tocState) == OrderbookTocStateEnum.MODIFY ? true : false,
            });
        }
    };
    const getIsBuy = () => {
        if ((props === null || props === void 0 ? void 0 : props.isBuy) !== undefined && (props === null || props === void 0 ? void 0 : props.isBuy) !== null) {
            return props === null || props === void 0 ? void 0 : props.isBuy;
        }
    };
    const getTocScreen = () => {
        var _a, _b;
        if (((_a = multiQuoteData === null || multiQuoteData === void 0 ? void 0 : multiQuoteData.multiQuote) === null || _a === void 0 ? void 0 : _a.quotesDetailsEntity) &&
            ((_b = multiQuoteData === null || multiQuoteData === void 0 ? void 0 : multiQuoteData.multiQuote) === null || _b === void 0 ? void 0 : _b.quotesDetailsEntity.length) > 0) {
            return tocRoutes.map((toc) => {
                var _a;
                if (toc.type === ((_a = multiQuoteData === null || multiQuoteData === void 0 ? void 0 : multiQuoteData.multiQuote) === null || _a === void 0 ? void 0 : _a.quotesDetailsEntity[0].type)) {
                    return (React.createElement(TocHoc, { component: toc.component, isBuy: getIsBuy(), setShowTOC: props.setShowTOC, outsideClick: (props === null || props === void 0 ? void 0 : props.outsideClick) && (props === null || props === void 0 ? void 0 : props.outsideClick), hideHeader: props.hideHeader, tocState: props === null || props === void 0 ? void 0 : props.tocState, modifyData: props === null || props === void 0 ? void 0 : props.modifyData, afterModifyAction: props === null || props === void 0 ? void 0 : props.afterModifyAction }));
                }
            });
        }
    };
    React.useEffect(() => {
        if (symbol)
            getMultiQuoteDetails(symbol);
    }, [symbol]);
    React.useEffect(() => {
        if (props === null || props === void 0 ? void 0 : props.symbol) {
            setSymbol(props === null || props === void 0 ? void 0 : props.symbol);
        }
        else if (!!queryParamSymbol) {
            setSymbol(queryParamSymbol);
        }
    }, [props === null || props === void 0 ? void 0 : props.symbol, queryParamSymbol]);
    React.useEffect(() => {
        getTocScreen();
    }, [(_a = multiQuoteData === null || multiQuoteData === void 0 ? void 0 : multiQuoteData.multiQuote) === null || _a === void 0 ? void 0 : _a.quotesDetailsEntity]);
    return React.createElement(React.Fragment, null, getTocScreen());
};
export default TocOnBuySell;
